// script.ts

document.addEventListener('DOMContentLoaded', () => {

  setTimeout(() => {

    const containers = document.querySelectorAll<HTMLElement>('[data-scroll]');

    containers.forEach(container => {
        const content = container.querySelector<HTMLElement>('[data-scroll-container]');

        if (!content) {
            console.warn('Content not found for container:', container);
            return;
        }

        // Create scrollbar element
        const scrollbar = document.createElement('div');
        scrollbar.classList.add('o-scrollbar');
        container.appendChild(scrollbar);

        const updateScrollbar = () => {
            const contentHeight = content.scrollHeight;
            const containerHeight = container.clientHeight;
            const scrollTop = content.scrollTop;

            if (contentHeight <= containerHeight) {
                // Hide scrollbar if content does not overflow
                scrollbar.style.display = 'none';
            } else {
                // Show and update scrollbar if content overflows
                scrollbar.style.display = 'block';
                const scrollbarHeight = (containerHeight / contentHeight) * containerHeight;
                const scrollbarTop = (scrollTop / contentHeight) * containerHeight;

                scrollbar.style.height = `${scrollbarHeight}px`;
                scrollbar.style.transform = `translateY(${scrollbarTop}px)`;
            }
        };

        content.addEventListener('scroll', updateScrollbar);

        // Initial update
        updateScrollbar();
    });

  }, 1000);
});
